<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="服务">
                  <el-input  v-model="queryForm.serviceId"></el-input>
              </el-form-item>
              <el-form-item label="价格">
                  <el-input  v-model="queryForm.servicePrice"></el-input>
              </el-form-item>
              <el-form-item label="允许改价">
                  <el-input  v-model="queryForm.allowChange"></el-input>
              </el-form-item>
              <el-form-item label="最小价格">
                  <el-input  v-model="queryForm.minPrice"></el-input>
              </el-form-item>
              <el-form-item label="最大价格">
                  <el-input  v-model="queryForm.maxPrice"></el-input>
              </el-form-item>
              <el-form-item label="默认">
                  <el-input  v-model="queryForm.isDefault"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashServicePriceList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashServicePrice"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashServicePrice(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashServicePrice(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportWashServicePriceList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashServicePriceList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washServicePriceList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="serviceId"
        label="服务"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="servicePrice"
        label="价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="allowChange"
        label="允许改价"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="minPrice"
        label="最小价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="maxPrice"
        label="最大价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isDefault"
        label="默认"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashServicePrice(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashServicePrice(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashServicePrice(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washServicePriceStates[washServicePriceState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washServicePrice"
          ref="washServicePriceForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="服务"
            prop="serviceId"
          >
            <el-input
              size="small"
              v-model="washServicePrice.serviceId"
              :disabled="washServicePriceState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="价格"
            prop="servicePrice"
          >
            <el-input
              size="small"
              v-model="washServicePrice.servicePrice"
              :disabled="washServicePriceState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="允许改价"
            prop="allowChange"
          >
            <el-input
              size="small"
              v-model="washServicePrice.allowChange"
              :disabled="washServicePriceState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最小价格"
            prop="minPrice"
          >
            <el-input
              size="small"
              v-model="washServicePrice.minPrice"
              :disabled="washServicePriceState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最大价格"
            prop="maxPrice"
          >
            <el-input
              size="small"
              v-model="washServicePrice.maxPrice"
              :disabled="washServicePriceState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="默认"
            prop="isDefault"
          >
            <el-input
              size="small"
              v-model="washServicePrice.isDefault"
              :disabled="washServicePriceState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washServicePriceState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashServicePriceList();
                    this.getWashServicePriceList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashServicePriceList();
                    this.getWashServicePriceList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     serviceId: '', //服务
                     servicePrice: '', //价格
                     allowChange: '', //允许改价
                     minPrice: '', //最小价格
                     maxPrice: '', //最大价格
                     isDefault: '', //默认
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washServicePriceState: 'add',
                washServicePriceStates: {
                    add: '新建wash_service_price',
                    check: '查看wash_service_price',
                    edit: '修改wash_service_price'
                },

                multipleSelection: [],
                washServicePriceList: [],
                washServicePrice: {
                    id: '', //ID
                    serviceId: '', //服务
                    servicePrice: '', //价格
                    allowChange: '', //允许改价
                    minPrice: '', //最小价格
                    maxPrice: '', //最大价格
                    isDefault: '', //默认
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    serviceId: [{ required: true, message: '服务不能为空', trigger: 'blur' }],
                    servicePrice: [{ required: true, message: '价格不能为空', trigger: 'blur' }],
                    allowChange: [{ required: true, message: '允许改价不能为空', trigger: 'blur' }],
                    minPrice: [{ required: true, message: '最小价格不能为空', trigger: 'blur' }],
                    maxPrice: [{ required: true, message: '最大价格不能为空', trigger: 'blur' }],
                    isDefault: [{ required: true, message: '默认不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getWashServicePriceList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetWashServicePriceList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washServicePriceList = [];
            },
            resetDialog() {
                this.washServicePriceState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      serviceId: '', //服务
                      servicePrice: '', //价格
                      allowChange: '', //允许改价
                      minPrice: '', //最小价格
                      maxPrice: '', //最大价格
                      isDefault: '', //默认
                };
                this.getWashServicePriceList();
            },
            closeDialog() {
                this.showDialog = false
                this.washServicePrice = {
                      id: '', //ID
                      serviceId: '', //服务
                      servicePrice: '', //价格
                      allowChange: '', //允许改价
                      minPrice: '', //最小价格
                      maxPrice: '', //最大价格
                      isDefault: '', //默认
                      createTime: '', //创建时间
                };
            },
            submitForm() {
                if (this.washServicePriceState == 'add') {
                    this.$refs.washServicePriceForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/serviceprice/add`,{ ...this.washServicePrice }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashServicePriceList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washServicePriceState == 'edit') {
                    this.$refs.washServicePriceForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/serviceprice/edit`,{ ...this.washServicePrice }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashServicePriceList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashServicePrice() {
                this.showDialog = true;
                this.washServicePriceState = 'add';
            },
            checkWashServicePrice(washServicePriceId) {
                console.log(washServicePriceId);
                this.currentWashServicePriceId = washServicePriceId;

                this.getWashServicePriceById();
                this.showDialog = true;
                this.washServicePriceState = 'check';
            },
            editWashServicePrice(washServicePriceId) {
                console.log('washServicePrice', washServicePriceId);
                if (washServicePriceId) {
                    this.currentWashServicePriceId = washServicePriceId;
                    this.getWashServicePriceById();
                } else {
                    this.washServicePrice = { ...this.washServicePrice, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washServicePriceState = 'edit';
            },
            deleteWashServicePrice(washServicePriceId) {
                let ids = '';
                if (washServicePriceId) {
                    ids = washServicePriceId;
                } else {
                    ids = this.multipleSelection.map((washServicePrice) => washServicePrice.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/wash/serviceprice/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashServicePriceList();
                                this.getWashServicePriceList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashServicePriceList() {
                this.resetWashServicePriceList();
                this.getWashServicePriceList();
            },
            getWashServicePriceList(query = {}) {
                this.loading = true;
                get(`/wash/serviceprice/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washServicePriceList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashServicePriceById() {
                get(`/wash/serviceprice/get`,{ id: this.currentWashServicePriceId }).then((res) =>{
                    if(res.success){
                      this.washServicePrice = { ...this.washServicePrice, ...res.washServicePrice };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashServicePriceList() {
                //this.btnLoading = true;
                exprotExcel(`/wash/serviceprice/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/wash/serviceprice/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/wash/serviceprice/importData`,formData);
              this.refreshWashServicePriceList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashServicePriceList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashServicePriceList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>